import React from 'react';
import FormObjectsTable from '@/forms/objects/components/FormObjectsTable';

const TaskObjectsTable = ({ field, text = [] }) => {
  const items = Array.isArray(text) ? text : [];
  const withDefaults = items.length > 0 ? items : field.defaultValue || [];
  return (<FormObjectsTable className="aridhia-task-object-table" field={field} items={withDefaults} />);
};

export default TaskObjectsTable;
